import React from 'react'
import ReactDOM from 'react-dom'

import './app/css/index.scss'
import App from './app/app'

ReactDOM.render(<App />, document.getElementById('root'))
